<div class="chapter-overview-main">
  <div
    class="top-chapter-bar"
    [ngClass]="{ 'less-height-cp': collapsed }">
    @for (chapter of usedChapters; track chapter; let i = $index) {
      <div
        class="chapter-icon-main"
        animate.enter="animate-chapter-in"
        animate.leave="animate-chapter-out"
        (click)="chapterClick(chapter)">
        @if (!collapsed) {
          <div
            class="chapter-icon top-chapter"
            animate.enter="fly-in-from-top"
            [ngClass]="{
              'chapter-icon--last': i === usedChapters.length - 1,
              'chapter-icon--inbetween': i !== 0 && i !== usedChapters.length - 1,
              'chapter-icon--first': i === 0
            }">
            <span class="material-icons-outlined">
              {{ chapter.content['icon'] ? chapter.content['icon'] : 'view_in_ar' }}
            </span>
          </div>
        }
        <p
          class="chapter-text"
          [ngClass]="{ 'chapter-text--first': i === 0, 'chapter-text--last': i === usedChapters.length - 1 }"
          animate.enter="fly-in-from-top">
          {{ chapter.content['text'] }}
        </p>
      </div>
      @if (i < usedChapters.length - 1) {
        <div class="chapter-line">
          <div class="flex-one"></div>
          <div
            class="chapter-line-item"
            [ngStyle]="{ background: collapsed ? 'transparent' : 'black' }"></div>
          <div class="flex-one"></div>
        </div>
      }
    }
  </div>
</div>
